/* eslint-disable react/no-array-index-key */
import * as React from 'react';
import { Link as LinkType } from '../../typings';
import { Link } from '../common';
import Carousel from '../Carousel';
import './styles.scss';

interface LinkCarouselProps {
  links: LinkType[];
}

const LinksCard = ({
  links,
}: LinkCarouselProps) => (
  <ul className="link-list__card">
    {links.map((link) => (
      <li key={link.url} className="link-list__item">
        <Link className="link-list__link" {...link} />
      </li>
    ))}
  </ul>
);

const LinkCarousel = ({
  links,
}: LinkCarouselProps) => {
  const cutOff = 4;
  const groupedLinks = new Array(Math.ceil(links.length / cutOff))
    .fill(null)
    .map((_, index) => links.slice(cutOff * index, cutOff * index + cutOff));

  const slickConfig = {
    slidesToShow: 2,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.1,
          arrows: true,
        },
      },
    ],
  };

  return (
    <Carousel
      slickConfig={slickConfig}
    >
      {groupedLinks.map((group, index) => (
        <LinksCard key={index} links={group} />
      ))}
    </Carousel>
  );
};

export default LinkCarousel;
